export const removeSlugs = (context) => () => ({
    type: "SITEMAP.SLUGS.REMOVE",
    payload: {},
    context,
});

export const generateSlugs = (context) => () => ({
    type: "SITEMAP.SLUGS.GENERATE",
    payload: {},
    context,
});
